import DatasetTitle from "components/basic/display-titles/DatasetTitle";
import { Dialog } from "primereact/dialog";
import React from "react";
import { T } from "services/lang/LanguageService";

interface DatasetsTitleDialogProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  identifiers: string[];
}

const DatasetsTitlesDialog = ({ isVisible, setIsVisible, identifiers }: DatasetsTitleDialogProps) => {
  return (
    <Dialog
      header={T("label.selected-datasets")}
      visible={isVisible}
      style={{ width: "50vw" }}
      onHide={() => setIsVisible(false)}
    >
      {identifiers.map(identifier => (
        <DatasetTitle key={identifier} identifier={identifier} />
      ))}
    </Dialog>
  );
};

export default DatasetsTitlesDialog;
